import {useRef,useMemo} from "react";
import UserDetailTravelTimeNewPopup from './UserDetailTravelTimeNewPopup.js';
import COMPONENT_MAP from '../Repository/Components.js';

const UserDetailTravelTime=({parentId,application,userData,eventCallback})=>{
    const list_name='user_travel_time';
    const executeQuery=useRef(true);
    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                application={application}
                userData={userData}
                entityType={'TravelTime'}
                entityParams={['system_user_id='+parentId,'_context='+['parent_name=SystemUser'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'UserDetailTravelTime.js'}
                initialState={{}}
                navigateOnNew={null}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={UserDetailTravelTimeNewPopup}
                parentContext={{parent_field_name:'system_user_id',parent_field_value:null,parent_name:'SystemUser'}}
                executeQuery={executeQuery}
            />
        ):null; 
    },[parentId,application,userData]);

    return(renderListTab);
}

export default UserDetailTravelTime;
